﻿; (function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		define(factory);
	} else {
		root.reMLSData = factory();
	}
}(this, function () {
	'use strict';

	/**
	* re_mls_data.
	* @exports mlsData
	* @author John Allan
	*/

	//#region data
	var data = [
		{
			integer: 0,
			string: 'Undefined'
		},
		{
			integer: 1,
			string: 'SFAR'
		},
		{
			integer: 2,
			string: 'SDAR'
		},
		{
			integer: 3,
			string: 'Miami'
		},
		{
			integer: 5,
			string: 'EBRD'
		},
		{
			integer: 6,
			string: 'RIAR'
		},
		{
			integer: 7,
			string: 'CCAR'
		},
		{
			integer: 8,
			string: 'BayEast'
		}
		,
		{
			integer: 9,
			string: 'BAREIS'
		}
	];
	//#endregion

	//#region methods
	var module = {
		browse: function () {
			return data;
		},
		read: function (query) {
			var key, result;

			result = null;

			if (!query) {
				return false;
			}

			key = (typeof query === 'number') ? 'integer' : 'string';
			
			data.forEach(function (item) {
				if (item[key] === query) {
					result = item;
				}
			});

			return result;
		}
	};

	return module;
	//#endregion

}));